export default {
  'Cases types': 'RODZAJE SKRZYŃ',
  'Possible contents of the case': 'Możliwa zawartość skrzynki',
  'Other cases': 'NNE SKRZYNIE',
  'Open for': 'Otwórz za',
};
